// extracted by mini-css-extract-plugin
module.exports = {"melDescription":"melDescription--3Xng9"};